import { DomainModel } from 'domains/models';
import TaxRate from '../tax_rate';
import { Currency } from './currency';
import { TaxRateType } from './tax_rate_type';

export default class ServicePrice extends DomainModel {
  serviceId: number;
  currency: Currency;
  unitAmount: number;
  taxRateType: TaxRateType;
  taxRateId: number | null;

  constructor(props: any) {
    super(props);
    this._className = 'ServicePrice';
    this.serviceId = props.serviceId;
    this.currency = props.currency;
    this.unitAmount = props.unitAmount;
    this.taxRateType = props.taxRateType;
    this.taxRateId = props.taxRateId;
  }

  static permited = ['currency', 'unitAmount', 'taxRateId', 'taxRateType'];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }

  isValid(scopes: string[] | null = null) {
    super.beforeValidate();
    let p = '';

    p = 'currency';
    if (!scopes || scopes.includes(p)) {
      if (this.currency !== Currency.JPY && this.currency !== Currency.USD) {
        this.addError(p, 'E001');
      }
    }

    p = 'unitAmount';
    if (!scopes || scopes.includes(p)) {
      if (typeof this.unitAmount !== 'number') {
        this.addError(p, 'E001');
      } else {
        if (!this.currency) {
          this.addError(p, 'E002');
        } else {
          // stripeの最低決済金額以上しか設定できない https://stripe.com/docs/currencies#%E6%9C%80%E5%B0%8F%E3%81%8A%E3%82%88%E3%81%B3%E6%9C%80%E5%A4%A7%E8%AB%8B%E6%B1%82%E9%87%91%E9%A1%8D
          if (this.currency === Currency.JPY) {
            if (this.unitAmount < 100) {
              this.addError(p, 'E003');
            }
            if (this.unitAmount >= 10000000) {
              this.addError(p, 'E005');
            }
            if (!Number.isInteger(this.unitAmount)) {
              this.addError(p, 'E007');
            }
          } else if (this.currency === Currency.USD) {
            if (this.unitAmount < 1) {
              this.addError(p, 'E004');
            }
            if (this.unitAmount >= 100000) {
              this.addError(p, 'E006');
            }
            if (this.unitAmount.toString().indexOf('.') !== -1) {
              const decimal = this.unitAmount.toString().split('.')[1];
              if (decimal.length > 2) {
                this.addError(p, 'E008');
              }
            }
          }
        }
      }
    }

    return super.isValid();
  }

  static getTaxRate(
    servicePrice: ServicePrice | null | undefined,
    taxRates: TaxRate[],
  ) {
    if (servicePrice) {
      if (servicePrice.taxRateType === TaxRateType.Default) {
        return TaxRate.defaultTaxRate(servicePrice.taxRateId);
      } else if (servicePrice.taxRateType === TaxRateType.Custom) {
        const taxRate = taxRates.find((r) => r.id === servicePrice.taxRateId);
        return taxRate || null;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
}
